import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Box from '@mui/material/Box';
import { FormGroup, Typography} from "@material-ui/core";
import LinearProgress from '@mui/material/LinearProgress';

import {
  getStudentLockedSessions,
  unlockSelSessions,
} from "../firebaseApi";
import { DialogContentText } from "@mui/material";

const styles = (theme) => ({});

function InstructorUnlockSelect(props) {
  let mobile = props.width === "sm" || props.width === "xs";

  const [lockedSessions, setLockedSessions] = React.useState([]);
  const [unlocking, setUnlocking] = React.useState(false);
  const [loadingSessions, setLoadingSessions] = React.useState(true);

  React.useEffect(() => {

    if (!props.open) {
      console.log("Closing popup");
      return;
    }
    let data = { 
      courseID: props.course.courseID,
      studentEmail: props.selectedStudent.email,
    };
    console.log(data);
    getStudentLockedSessions(data).then((sessions) => {
      let lockedSessions = [];
      const sessionData = Object.entries(sessions);
      console.log(sessionData);
      for (const [sessionID, data] of sessionData) {
        let newData = {
          sessionID: sessionID,
          sessionName: "Session " + data.sessionNum,
          checked: sessionID == sessionData[sessionData.length-1][0] ? true : false,
          lockoutPoll: data.lockoutPoll,
          date: data.date,
        }
        lockedSessions.push(newData);
      }
      setLockedSessions(lockedSessions);
      setLoadingSessions(false);
      console.log("Done setting up");
    });
  }, [props.selectedStudent]);

  function handleCheck(index) {
    const updatedSessions = [...lockedSessions];
    updatedSessions[index].checked = !lockedSessions[index].checked;
    setLockedSessions(updatedSessions);
  }

  function unlockSelectedSessions() {
    console.log("unlocking");
    setUnlocking(true);
    let selectedSessions = [];

    for (let i=0; i<lockedSessions.length; i++) {

      if (lockedSessions[i].checked === true) {
        selectedSessions.push(lockedSessions[i].sessionID);
      }
    }
    let data = {
      courseID: props.course.courseID,
      studentEmail: props.selectedStudent.email,
      selSessions: selectedSessions,
    };
    unlockSelSessions(data).then(() => {
      console.log("returning to main popup");
      props.setRerender();
      props.setUnlockStudent(true);
      props.openSelect(false);
    });
  }

  return (
    <Dialog 
      fullScreen={mobile}
      fullWidth
      maxWidth="sm"
      open={props.open}
      onClose={() => {
        props.openSelect(false);
      }}
    >
      <DialogTitle 
        style = {{
          backgroundColor:"white", 
          zIndex:"10",
        }}
      >
        {"Unlock Sessions for " + props.selectedStudent.firstName + " " + props.selectedStudent.lastName}
      </DialogTitle>
      <Box sx={{ml: 3, mr: 3}}>
        <DialogContentText>
          If no sessions are selected, the student's account will be unlocked but past polls will not be cleared.
        </DialogContentText>
        {loadingSessions && <LinearProgress style={{ marginTop: 30, marginBottom: 15 }} />}
        <FormGroup>
          {lockedSessions.map((sessionData, index) => ( 
            <FormControlLabel
              style={{marginTop: "10px"}}
              key={index}
              onClick={(e)=>{e.stopPropagation();}} //stops the accordian from being annoying
              control={
                <Checkbox
                  checked={sessionData.checked}
                  onChange={(e)=>{
                    handleCheck(index);
                  }}
                  name={`checkbox-${index}`}
                />
              }
              label={<Typography>{sessionData.sessionName + " - " + sessionData.date + (sessionData.lockoutPoll ? " (Lockout Poll)" : "")}</Typography>}
            />
          ))}
        </FormGroup>
      </Box>
      <DialogActions >
        <Button
          color="primary"
          onClick={() => {
            props.openSelect(false);
          }}
        >
          Cancel
        </Button>
        <Button
        color="primary"
        onClick={() => {
          unlockSelectedSessions();
        }}
        disabled={unlocking || loadingSessions}
      >
        Unlock
      </Button>
      </DialogActions>
    </Dialog>);
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(
      withWidth()(InstructorUnlockSelect)
    )
  )
);